export const USER_LOGIN_ACTION = "USER_LOGIN_ACTION";
export const USER_LOGIN_LOADING = "USER_LOGIN_LOADING";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_ERROR = "USER_LOGIN_ERROR";
export const USER_GET_VERIFICATION_CODE_ACTION =
  "USER_GET_VERIFICATION_CODE_ACTION";
export const USER_GET_VERIFICATION_CODE_LOADING =
  "USER_GET_VERIFICATION_CODE_LOADING";
export const USER_GET_VERIFICATION_CODE_SUCCESS =
  "USER_GET_VERIFICATION_CODE_SUCCESS";
export const USER_GET_VERIFICATION_CODE_ERROR =
  "USER_GET_VERIFICATION_CODE_ERROR";
export const USER_LOGGED_IN_ACTION = "USER_LOGGED_IN_ACTION";
export const USER_LOGGED_IN_LOADING = "USER_LOGGED_IN_LOADING";
export const USER_LOGGED_IN_SUCCESS = "USER_LOGGED_IN_SUCCESS";
export const USER_LOGGED_IN_ERROR = "USER_LOGGED_IN_ERROR";
export const USER_CHANGE_PASSWORD_ACTION = "USER_CHANGE_PASSWORD_ACTION";
export const USER_CHANGE_PASSWORD_LOADING = "USER_CHANGE_PASSWORD_LOADING";
export const USER_CHANGE_PASSWORD_SUCCESS = "USER_CHANGE_PASSWORD_SUCCESS";
export const USER_CHANGE_PASSWORD_ERROR = "USER_CHANGE_PASSWORD_ERROR";
export const USER_REGISTER_ACTION = "USER_REGISTER_ACTION";
export const USER_REGISTER_LOADING = "USER_REGISTER_LOADING";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_ERROR = "USER_REGISTER_ERROR";
export const USER_LOGOUT_ACTION = "USER_LOGOUT_ACTION";
export const USER_LOGOUT_LOADING = "USER_LOGOUT_LOADING";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_ERROR = "USER_LOGOUT_ERROR";
export const USER_UPDATE_ACTION = "USER_UPDATE_ACTION";
export const USER_UPDATE_LOADING = "USER_UPDATE_LOADING";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATE_ERROR = "USER_UPDATE_ERROR";
export const USER_PASSWORD_UPDATE_ACTION = "USER_PASSWORD_UPDATE_ACTION";
export const USER_PASSWORD_UPDATE_LOADING = "USER_PASSWORD_UPDATE_LOADING";
export const USER_PASSWORD_UPDATE_SUCCESS = "USER_PASSWORD_UPDATE_SUCCESS";
export const USER_PASSWORD_UPDATE_ERROR = "USER_PASSWORD_UPDATE_ERROR";
export const USER_FETCH_ACTION = "USER_FETCH_ACTION";
export const USER_FETCH_LOADING = "USER_FETCH_LOADING";
export const USER_FETCH_SUCCESS = "USER_FETCH_SUCCESS";
export const USER_FETCH_ERROR = "USER_FETCH_ERROR";
export const USER_GET_ACTION = "USER_GET_ACTION";
export const USER_GET_LOADING = "USER_GET_LOADING";
export const USER_GET_SUCCESS = "USER_GET_SUCCESS";
export const USER_GET_ERROR = "USER_GET_ERROR";
export const USER_DELETE_ACTION = "USER_DELETE_ACTION";
export const USER_DELETE_SUCCESS = "USER_DELETE_SUCCESS";
export const USER_DELETE_ERROR = "USER_DELETE_ERROR";
export const USER_CHANGE_STATUS_ACTION = "USER_CHANGE_STATUS_ACTION";
export const USER_CHANGE_STATUS_SUCCESS = "USER_CHANGE_STATUS_SUCCESS";
export const USER_CHANGE_STATUS_ERROR = "USER_CHANGE_STATUS_ERROR";
export const USER_VERIFY_CODE_ACTION = "USER_VERIFY_CODE_ACTION";
export const USER_VERIFY_CODE_LOADING = "USER_VERIFY_CODE_LOADING";
export const USER_VERIFY_CODE_SUCCESS = "USER_VERIFY_CODE_SUCCESS";
export const USER_VERIFY_CODE_ERROR = "USER_VERIFY_CODE_ERROR";
export const USER_UPDATE_PASSWORD_ACTION = "USER_UPDATE_PASSWORD_ACTION";
export const USER_UPDATE_PASSWORD_LOADING = "USER_UPDATE_PASSWORD_LOADING";
export const USER_UPDATE_PASSWORD_SUCCESS = "USER_UPDATE_PASSWORD_SUCCESS";
export const USER_UPDATE_PASSWORD_ERROR = "USER_UPDATE_PASSWORD_ERROR";
export const LEAVES_FETCH_ACTION = "LEAVES_FETCH_ACTION";
export const LEAVES_FETCH_LOADING = "LEAVES_FETCH_LOADING";
export const LEAVES_FETCH_SUCCESS = "LEAVES_FETCH_SUCCESS";
export const LEAVES_FETCH_ERROR = "LEAVES_FETCH_ERROR";
export const LEAVES_DELETE_ACTION = "LEAVES_DELETE_ACTION";
export const LEAVES_DELETE_SUCCESS = "LEAVES_DELETE_SUCCESS";
export const LEAVES_DELETE_ERROR = "LEAVES_DELETE_ERROR";
export const LEAVES_ADD_LOADING = "LEAVES_ADD_LOADING";
export const LEAVES_ADD_ACTION = "LEAVES_ADD_ACTION";
export const LEAVES_ADD_SUCCESS = "LEAVES_ADD_SUCCESS";
export const LEAVES_ADD_ERROR = "LEAVES_ADD_ERROR";
export const LEAVES_GET_LOADING = "LEAVES_GET_LOADING";
export const LEAVES_GET_ACTION = "LEAVES_GET_ACTION";
export const LEAVES_GET_SUCCESS = "LEAVES_GET_SUCCESS";
export const LEAVES_GET_ERROR = "LEAVES_GET_ERROR";
export const LEAVES_UPDATE_LOADING = "LEAVES_UPDATE_LOADING";
export const LEAVES_UPDATE_ACTION = "LEAVES_UPDATE_ACTION";
export const LEAVES_REJECT_STATUS_ACTION = "LEAVES_REJECT_STATUS_ACTION";
export const LEAVES_REJECT_STATUS_LOADING = "LEAVES_REJECT_STATUS_LOADING";
export const LEAVES_REJECT_STATUS_SUCCESS = "LEAVES_REJECT_STATUS_SUCCESS";
export const LEAVES_REJECT_STATUS_ERROR = "LEAVES_REJECT_STATUS_ERROR";

export const LEAVES_UPDATE_STATUS_ACTION = "LEAVES_UPDATE_STATUS_ACTION";
export const LEAVES_UPDATE_STATUS_LOADING = "LEAVES_UPDATE_STATUS_LOADING";
export const LEAVES_UPDATE_STATUS_SUCCESS = "LEAVES_UPDATE_STATUS_SUCCESS";
export const LEAVES_UPDATE_STATUS_ERROR = "LEAVES_UPDATE_STATUS_ERROR";
export const LEAVES_UPDATE_SUCCESS = "LEAVES_UPDATE_SUCCESS";
export const LEAVES_UPDATE_ERROR = "LEAVES_UPDATE_ERROR";
export const ASSETS_FETCH_ACTION = "ASSETS_FETCH_ACTION";
export const ASSETS_FETCH_LOADING = "ASSETS_FETCH_LOADING";
export const ASSETS_ADD_ACTION = "ASSETS_ADD_ACTION";
export const ASSETS_ADD_SUCCESS = "ASSETS_ADD_SUCCESS";
export const ASSETS_FETCH_SUCCESS = "ASSETS_FETCH_SUCCESS";
export const ASSETS_FETCH_ERROR = "ASSETS_FETCH_ERROR";
export const ASSETS_ADD_LOADING = "ASSETS_ADD_LOADING";
export const ASSETS_UPDATE_ACTION = "ASSETS_UPDATE_ACTION";
export const ASSETS_UPDATE_LOADING = "ASSETS_UPDATE_LOADING";
export const ASSETS_UPDATE_SUCCESS = "ASSETS_UPDATE_SUCCESS";
export const ASSETS_UPDATE_ERROR = "ASSETS_UPDATE_ERROR";
export const ASSETS_DELETE_ACTION = "ASSETS_DELETE_ACTION";
export const ASSETS_DELETE_SUCCESS = "ASSETS_DELETE_SUCCESS";
export const ASSETS_DELETE_ERROR = "ASSETS_DELETE_ERROR";
export const ASSETS_ADD_ERROR = "ASSETS_ADD_ERROR";
export const ASSETS_GET_ACTION = "ASSETS_GET_ACTION";
export const ASSETS_GET_LOADING = "ASSETS_GET_LOADING";
export const ASSETS_GET_SUCCESS = "ASSETS_GET_SUCCESS";
export const ASSETS_GET_ERROR = "ASSETS_GET_ERROR";
export const ASSIGN_ASSET_GET_ACTION = "ASSIGN_ASSET_GET_ACTION";
export const ASSIGN_ASSET_GET_LOADING = "ASSIGN_ASSET_GET_LOADING";
export const ASSIGN_ASSET_GET_SUCCESS = "ASSIGN_ASSET_GET_SUCCESS";
export const ASSIGN_ASSET_GET_ERROR = "ASSIGN_ASSET_GET_ERROR";
export const ASSIGN_ASSET_FETCH_ACTION = "ASSIGN_ASSET_FETCH_ACTION";
export const ASSIGN_ASSET_FETCH_LOADING = "ASSIGN_ASSET_FETCH_LOADING";
export const ASSIGN_ASSET_FETCH_ERROR = "ASSIGN_ASSET_FETCH_ERROR";
export const ASSIGN_ASSET_FETCH_SUCCESS = "ASSIGN_ASSET_FETCH_SUCCESS";
export const ASSIGN_ASSET_ADD_ACTION = "ASSIGN_ASSET_ADD_ACTION";
export const ASSIGN_ASSET_ADD_SUCCESS = "ASSIGN_ASSET_ADD_SUCCESS";
export const ASSIGN_ASSET_ADD_LOADING = "ASSIGN_ASSET_ADD_LOADING";
export const ASSIGN_ASSET_ADD_ERROR = "ASSIGN_ASSET_ADD_ERROR";
export const ASSIGN_ASSET_DELETE_ACTION = "ASSIGN_ASSET_DELETE_ACTION";
export const ASSIGN_ASSET_DELETE_SUCCESS = "ASSIGN_ASSET_DELETE_SUCCESS";
export const ASSIGN_ASSET_DELETE_ERROR = "ASSIGN_ASSET_DELETE_ERROR";
export const ASSIGN_ASSET_UPDATE_ACTION = "ASSIGN_ASSET_UPDATE_ACTION";
export const ASSIGN_ASSET_UPDATE_SUCCESS = "ASSIGN_ASSET_UPDATE_SUCCESS";
export const ASSIGN_ASSET_UPDATE_ERROR = "ASSIGN_ASSET_UPDATE_ERROR";
export const ASSIGN_ASSET_UPDATE_LOADING = "ASSIGN_ASSET_UPDATE_LOADING";
export const HOLIDAYS_FETCH_ACTION = "HOLIDAYS_FETCH_ACTION";
export const HOLIDAYS_FETCH_LOADING = "HOLIDAYS_FETCH_LOADING";
export const HOLIDAYS_FETCH_SUCCESS = "HOLIDAYS_FETCH_SUCCESS";
export const HOLIDAYS_FETCH_ERROR = "HOLIDAYS_FETCH_ERROR";
export const HOLIDAYS_DELETE_ACTION = "HOLIDAYS_DELETE_ACTION";
export const HOLIDAYS_DELETE_SUCCESS = "HOLIDAYS_DELETE_SUCCESS";
export const HOLIDAYS_DELETE_ERROR = "HOLIDAYS_DELETE_ERROR";
export const HOLIDAYS_ADD_LOADING = "HOLIDAYS_ADD_LOADING";
export const HOLIDAYS_ADD_ACTION = "HOLIDAYS_ADD_ACTION";
export const HOLIDAYS_ADD_SUCCESS = "HOLIDAYS_ADD_SUCCESS";
export const HOLIDAYS_ADD_ERROR = "HOLIDAYS_ADD_ERROR";
export const HOLIDAYS_GET_LOADING = "HOLIDAYS_GET_LOADING";
export const HOLIDAYS_GET_ACTION = "HOLIDAYS_GET_ACTION";
export const HOLIDAYS_GET_SUCCESS = "HOLIDAYS_GET_SUCCESS";
export const HOLIDAYS_GET_ERROR = "HOLIDAYS_GET_ERROR";
export const HOLIDAYS_UPDATE_LOADING = "HOLIDAYS_UPDATE_LOADING";
export const HOLIDAYS_UPDATE_ACTION = "HOLIDAYS_UPDATE_ACTION";
export const HOLIDAYS_UPDATE_SUCCESS = "HOLIDAYS_UPDATE_SUCCESS";
export const HOLIDAYS_UPDATE_ERROR = "HOLIDAYS_UPDATE_ERROR";
export const SALARY_SETTINGS_GET_LOADING = "SALARY_SETTINGS_GET_LOADING";
export const SALARY_SETTINGS_GET_ACTION = "SALARY_SETTINGS_GET_ACTION";
export const SALARY_SETTINGS_GET_SUCCESS = "SALARY_SETTINGS_GET_SUCCESS";
export const SALARY_SETTINGS_GET_ERROR = "SALARY_SETTINGS_GET_ERROR";
export const SALARY_SETTINGS_UPDATE_LOADING = "SALARY_SETTINGS_UPDATE_LOADING";
export const SALARY_SETTINGS_UPDATE_ACTION = "SALARY_SETTINGS_UPDATE_ACTION";
export const SALARY_SETTINGS_UPDATE_SUCCESS = "SALARY_SETTINGS_UPDATE_SUCCESS";
export const SALARY_SETTINGS_UPDATE_ERROR = "SALARY_SETTINGS_UPDATE_ERROR";
export const APPROVED_LEAVES_GET_LOADING = "APPROVED_LEAVES_GET_LOADING";
export const APPROVED_LEAVES_GET_ACTION = "APPROVED_LEAVES_GET_ACTION";
export const APPROVED_LEAVES_GET_SUCCESS = "APPROVED_LEAVES_GET_SUCCESS";
export const APPROVED_LEAVES_GET_ERROR = "APPROVED_LEAVES_GET_ERROR";
export const AVAILABLE_LEAVES_GET_LOADING = "AVAILABLE_LEAVES_GET_LOADING";
export const AVAILABLE_LEAVES_GET_ACTION = "AVAILABLE_LEAVES_GET_ACTION";
export const AVAILABLE_LEAVES_GET_SUCCESS = "AVAILABLE_LEAVES_GET_SUCCESS";
export const AVAILABLE_LEAVES_GET_ERROR = "AVAILABLE_LEAVES_GET_ERROR";
export const BALANCE_FETCH_ACTION = "BALANCE_FETCH_ACTION";
export const BALANCE_GET_ERROR = "BALANCE_GET_ERROR";
export const BALANCE_GET_SUCCESS = "BALANCE_GET_SUCCESS";
export const BALANCE_GET_LOADING = "BALANCE_GET_LOADING";
export const BALANCE_FETCH_SUCCESS = "BALANCE_FETCH_SUCCESS";
export const BALANCE_FETCH_ERROR = "BALANCE_FETCH_ERROR";
export const BALANCE_FETCH_LOADING = "BALANCE_FETCH_LOADING";
export const BALANCE_FETCH_BY_YEAR_ACTION = "BALANCE_FETCH_BY_YEAR_ACTION";
export const BALANCE_FETCH_BY_YEAR_LOADING = "BALANCE_FETCH_BY_YEAR_LOADING";
export const BALANCE_FETCH_BY_YEAR_ERROR = "BALANCE_FETCH_BY_YEAR_ERROR";
export const BALANCE_FETCH_BY_YEAR_SUCCESS = "BALANCE_FETCH_BY_YEAR_SUCCESS";
export const BALANCE_FETCH_BY_EMP_LOADING = "BALANCE_FETCH_BY_EMP_LOADING";
export const BALANCE_FETCH_BY_EMP_ERROR = "BALANCE_FETCH_BY_EMP_ERROR";
export const BALANCE_FETCH_BY_EMP_SUCCESS = "BALANCE_FETCH_BY_EMP_SUCCESS";
export const BALANCE_FETCH_BY_EMP_ACTION = "BALANCE_FETCH_BY_EMP_ACTION";
//
export const DOCUMENT_TYPES_FETCH_ACTION = "DOCUMENT_TYPES_FETCH_ACTION";
export const DOCUMENT_TYPES_FETCH_LOADING = "DOCUMENT_TYPES_FETCH_LOADING";
export const DOCUMENT_TYPES_FETCH_SUCCESS = "DOCUMENT_TYPES_FETCH_SUCCESS";
export const DOCUMENT_TYPES_FETCH_ERROR = "DOCUMENT_TYPES_FETCH_ERROR";
export const DOCUMENTS_FETCH_ACTION = "DOCUMENTS_FETCH_ACTION";
export const DOCUMENTS_FETCH_LOADING = "DOCUMENTS_FETCH_LOADING";
export const DOCUMENTS_FETCH_SUCCESS = "DOCUMENTS_FETCH_SUCCESS";
export const DOCUMENTS_FETCH_ERROR = "DOCUMENTS_FETCH_ERROR";
export const USER_DOCUMENT_FETCH_ACTION = "USER_DOCUMENT_FETCH_ACTION";
export const USER_DOCUMENT_FETCH_LOADING = "USER_DOCUMENT_FETCH_LOADING";
export const USER_DOCUMENT_FETCH_SUCCESS = "USER_DOCUMENT_FETCH_SUCCESS";
export const USER_DOCUMENT_FETCH_ERROR = "USER_DOCUMENT_FETCH_ERROR";
export const DOCUMENT_UPLOAD_ACTION = "DOCUMENT_UPLOAD_ACTION";
export const DOCUMENT_UPLOAD_LOADING = "DOCUMENT_UPLOAD_LOADING";
export const DOCUMENT_UPLOAD_SUCCESS = "DOCUMENT_UPLOAD_SUCCESS";
export const DOCUMENT_UPLOAD_ERROR = "DOCUMENT_UPLOAD_ERROR";
export const DOCUMENT_DELETE_ACTION = "DOCUMENT_DELETE_ACTION";
export const DOCUMENT_DELETE_LOADING = "DOCUMENT_DELETE_LOADING";
export const DOCUMENT_DELETE_SUCCESS = "DOCUMENT_DELETE_SUCCESS";
export const DOCUMENT_DELETE_ERROR = "DOCUMENT_DELETE_ERROR";
export const DOCUMENT_FILTER_ACTION = "DOCUMENT_FILTER_ACTION";
export const DOCUMENT_FILTER_LOADING = "DOCUMENT_FILTER_LOADING";
export const DOCUMENT_FILTER_SUCCESS = "DOCUMENT_FILTER_SUCCESS";
export const DOCUMENT_FILTER_ERROR = "DOCUMENT_FILTER_ERROR";
export const TECH_STACK_FETCH_ACTION = "TECH_STACK_FETCH_ACTION";
export const TECH_STACK_FETCH_LOADING = "TECH_STACK_FETCH_LOADING";
export const TECH_STACK_FETCH_SUCCESS = "TECH_STACK_FETCH_SUCCESS";
export const TECH_STACK_FETCH_ERROR = "TECH_STACK_FETCH_ERROR";
export const PROJECT_ADD_ACTION = "PROJECT_ADD_ACTION";
export const PROJECT_ADD_LOADING = "PROJECT_ADD_LOADING";
export const PROJECT_ADD_SUCCESS = "PROJECT_ADD_SUCCESS";
export const PROJECT_ADD_ERROR = "PROJECT_ADD_ERROR";
export const PROJECT_UPDATE_ACTION = "PROJECT_UPDATE_ACTION";
export const PROJECT_UPDATE_LOADING = "PROJECT_UPDATE_LOADING";
export const PROJECT_UPDATE_SUCCESS = "PROJECT_UPDATE_SUCCESS";
export const PROJECT_UPDATE_ERROR = "PROJECT_UPDATE_ERROR";
export const PROJECT_DELETE_ACTION = "PROJECT_DELETE_ACTION";
export const PROJECT_DELETE_LOADING = "PROJECT_DELETE_LOADING";
export const PROJECT_DELETE_SUCCESS = "PROJECT_DELETE_SUCCESS";
export const PROJECT_DELETE_ERROR = "PROJECT_DELETE_ERROR";
export const PROJECT_FETCH_LOADING = "PROJECT_FETCH_LOADING";
export const PROJECT_FETCH_ACTION = "PROJECT_FETCH_ACTION";
export const PROJECT_FETCH_SUCCESS = "PROJECT_FETCH_SUCCESS";
export const PROJECT_FETCH_ERROR = "PROJECT_FETCH_ACTION";
export const PROJECT_GET_ACTION = "PROJECT_GET_ACTION";
export const PROJECT_GET_SUCCESS = "PROJECT_GET_SUCCESS";
export const PROJECT_GET_LOADING = "PROJECT_GET_LOADING";
export const PROJECT_GET_ERROR = "PROJECT_GET_ERROR";
export const PROJECT_CLOSE_ACTION = "PROJECT_CLOSE_ACTION";
export const PROJECT_CLOSE_LOADING = "PROJECT_CLOSE_LOADING";
export const PROJECT_CLOSE_SUCCESS = "PROJECT_CLOSE_SUCCESS";
export const PROJECT_CLOSE_ERROR = "PROJECT_CLOSE_ERROR";
export const ACTIVE_PROJECT_LOADING = "ACTIVE_PROJECT_LOADING";
export const ACTIVE_PROJECT_SUCCESS = "ACTIVE_PROJECT_SUCCESS";
export const ACTIVE_PROJECT_ACTION = "ACTIVE_PROJECT_ACTION";
export const ACTIVE_PROJECT_ERROR = "ACTIVE_PROJECT_ERROR";
export const ADD_PROJECT_LOADING = "ADD_PROJECT_LOADING";
export const ADD_PROJECT_SUCCESS = "ADD_PROJECT_SUCCESS";
export const ADD_PROJECT_ACTION = "ADD_PROJECT_ACTION";
export const ADD_PROJECT_ERROR = "ADD_PROJECT_ERROR";
export const FILTER_ASSET_SUCCESS = "FILTER_ASSET_SUCCESS";
export const FILTER_ASSET_ACTION = "FILTER_ASSET_ACTION";
export const FILTER_ASSET_ERROR = "FILTER_ASSET_ERROR";
export const FILTER_ASSET_LOADING = "FILTER_ASSET_LOADING";
// time entry
export const ADD_TIME_ENTRY_ACTION = "ADD_TIME_ENTRY_ACTION";
export const ADD_TIME_ENTRY_LOADING = "ADD_TIME_ENTRY_LOADING";
export const ADD_TIME_ENTRY_ERROR = "ADD_TIME_ENTRY_ERROR";
export const ADD_TIME_ENTRY_SUCCESS = "ADD_TIME_ENTRY_SUCCESS";
export const GET_TIME_ENTRY_ACTION = "GET_TIME_ENTRY_ACTION";
export const GET_TIME_ENTRY_LOADING = "GET_TIME_ENTRY_LOADING";
export const GET_TIME_ENTRY_SUCCESS = "GET_TIME_ENTRY_SUCCESS";
export const GET_TIME_ENTRY_ERROR = "GET_TIME_ENTRY_ERROR";
export const GET_PROJECT_LOADING = "GET_PROJECT_LOADING";
export const GET_PROJECT_SUCCESS = "GET_PROJECT_SUCCESS";
export const GET_PROJECT_ACTION = "GET_PROJECT_ACTION";
export const GET_PROJECT_ERROR = "GET_PROJECT_ERROR";
export const UPDATE_FLAG_LOADING = "UPDATE_FLAG_LOADING";
export const UPDATE_FLAG_SUCCESS = "UPDATE_FLAG_SUCCESS";
export const UPDATE_FLAG_ACTION = "UPDATE_FLAG_ACTION";
export const UPDATE_FLAG_ERROR = "UPDATE_FLAG_ERROR";
export const UPDATE_ENTRY_ACTION = "UPDATE_ENTRY_ACTION";
export const UPDATE_ENTRY_LOADING = "UPDATE_ENTRY_LOADING";
export const UPDATE_ENTRY_SUCCESS = "UPDATE_ENTRY_SUCCESS";
export const UPDATE_ENTRY_ERROR = "UPDATE_ENTRY_ERROR";
export const DELETE_ENTRY_ACTION = "DELETE_ENTRY_ACTION";
export const DELETE_ENTRY_LOADING = "DELETE_ENTRY_LOADING";
export const DELETE_ENTRY_ERROR = "DELETE_ENTRY_ERROR";
export const DELETE_ENTRY_SUCCESS = "DELETE_ENTRY_SUCCESS";
export const GET_ENTRY_ACTION = "GET_ENTRY_ACTION";
export const GET_ENTRY_ERROR = "GET_ENTRY_ERROR";
export const GET_ENTRY_LOADING = "GET_ENTRY_LOADING";
export const GET_ENTRY_SUCCESS = "GET_ENTRY_SUCCESS";
export const GET_ALL_ENTRIES_ACTION = "GET_ALL_ENTRIES_ACTION";
export const GET_ALL_ENTRIES_LOADING = "GET_ALL_ENTRIES_LOADING";
export const GET_ALL_ENTRIES_SUCCESS = "GET_ALL_ENTRIES_SUCCESS";
export const GET_ALL_ENTRIES_ERROR = "GET_ALL_ENTRIES_ERROR";
export const WEEK_PROJECT_ACTION = "WEEK_PROJECT_ACTION";
export const WEEK_PROJECT_ERROR = "WEEK_PROJECT_ERROR";
export const WEEK_PROJECT_LOADING = "WEEK_PROJECT_LOADING";
export const WEEK_PROJECT_SUCCESS = "WEEK_PROJECT_SUCCESS";
export const LEAVE_BALANCE_GET_ACTION = "LEAVE_BALANCE_GET_ACTION";
export const LEAVE_BALANCE_GET_LOADING = "LEAVE_BALANCE_GET_LOADING";
export const LEAVE_BALANCE_GET_SUCCESS = "LEAVE_BALANCE_GET_SUCCESS";
export const LEAVE_BALANCE_GET_ERROR = "LEAVE_BALANCE_GET_ERROR";
export const CHECK_SALARY_ADD_ACTION = "CHECK_SALARY_ADD_ACTION";
export const CHECK_SALARY_ADD_LOADING = "CHECK_SALARY_ADD_LOADING";
export const CHECK_SALARY_ADD_SUCCESS = "CHECK_SALARY_ADD_SUCCESS";
export const CHECK_SALARY_ADD_ERROR = "CHECK_SALARY_ADD_ERROR";
export const CALCULATED_SALARY_ADD_ACTION = "CALCULATED_SALARY_ADD_ACTION";
export const CALCULATED_SALARY_ADD_LOADING = "CALCULATED_SALARY_ADD_LOADING";
export const CALCULATED_SALARY_ADD_SUCCESS = "CALCULATED_SALARY_ADD_SUCCESS";
export const CALCULATED_SALARY_ADD_ERROR = "CALCULATED_SALARY_ADD_ERROR";
export const CALCULATED_SALARY_GET_ACTION = "CALCULATED_SALARY_GET_ACTION";
export const CALCULATED_SALARY_GET_LOADING = "CALCULATED_SALARY_GET_LOADING";
export const CALCULATED_SALARY_GET_SUCCESS = "CALCULATED_SALARY_GET_SUCCESS";
export const CALCULATED_SALARY_GET_ERROR = "CALCULATED_SALARY_GET_ERROR";
export const CALCULATED_SALARY_DELETE_ACTION =
  "CALCULATED_SALARY_DELETE_ACTION";
export const CALCULATED_SALARY_DELETE_LOADING =
  "CALCULATED_SALARY_DELETE_LOADING";
export const CALCULATED_SALARY_DELETE_SUCCESS =
  "CALCULATED_SALARY_DELETE_SUCCESS";
export const CALCULATED_SALARY_DELETE_ERROR = "CALCULATED_SALARY_DELETE_ERROR";
export const CALCULATED_SALARY_GET_PDF_ACTION =
  "CALCULATED_SALARY_GET_PDF_ACTION";
export const CALCULATED_SALARY_GET_PDF_LOADING =
  "CALCULATED_SALARY_GET_PDF_LOADING";
export const CALCULATED_SALARY_GET_PDF_SUCCESS =
  "CALCULATED_SALARY_GET_PDF_SUCCESS";
export const CALCULATED_SALARY_GET_PDF_ERROR =
  "CALCULATED_SALARY_GET_PDF_ERROR";
export const UPCOMING_HOLIDAYS_FETCH_ACTION = "UPCOMING_HOLIDAYS_FETCH_ACTION";
export const UPCOMING_HOLIDAYS_FETCH_LOADING =
  "UPCOMING_HOLIDAYS_FETCH_LOADING";
export const UPCOMING_HOLIDAYS_FETCH_SUCCESS =
  "UPCOMING_HOLIDAYS_FETCH_SUCCESS";
export const UPCOMING_HOLIDAYS_FETCH_ERROR = "UPCOMING_HOLIDAYS_FETCH_ERROR";
export const UPCOMING_LEAVES_FETCH_ACTION = "UPCOMING_LEAVES_FETCH_ACTION";
export const UPCOMING_LEAVES_FETCH_LOADING = "UPCOMING_LEAVES_FETCH_LOADING";
export const UPCOMING_LEAVES_FETCH_SUCCESS = "UPCOMING_LEAVES_FETCH_SUCCESS";
export const UPCOMING_LEAVES_FETCH_ERROR = "UPCOMING_LEAVES_FETCH_ERROR";
export const UPCOMING_EVENTS_FETCH_ACTION = "UPCOMING_EVENTS_FETCH_ACTION";
export const UPCOMING_EVENTS_FETCH_LOADING = "UPCOMING_EVENTS_FETCH_LOADING";
export const UPCOMING_EVENTS_FETCH_SUCCESS = "UPCOMING_EVENTS_FETCH_SUCCESS";
export const UPCOMING_EVENTS_FETCH_ERROR = "UPCOMING_EVENTS_FETCH_ERROR";
export const RESET_RESULT = "RESET_RESULT";
export const RESET_MESSAGES = "RESET_MESSAGES";
export const USER_RESET_PASSWORD_EMAIL = "USER_RESET_PASSWORD_EMAIL";
export const USER_VERIFICATION_CODE = "USER_VERIFICATION_CODE";
export const RESET_USER_RESULT = "RESET_USER_RESULT";
export const RESET_PDF_RESULTS = "RESET_PDF_RESULTS";
// salary range
export const SALARY_RANGE_GET_ACTION = "SALARY_RANGE_GET_ACTION";
export const SALARY_RANGE_GET_SUCCESS = "SALARY_RANGE_GET_SUCCESS";
export const SALARY_RANGE_GET_ERROR = "SALARY_RANGE_GET_ERROR";
// leave balance update
export const UPDATED_LEAVE_BALANCE_ACTION = "UPDATED_LEAVE_BALANCE_ACTION";
export const UPDATED_LEAVE_BALANCE_SUCCESS = "UPDATED_LEAVE_BALANCE_SUCCESS";
export const UPDATED_LEAVE_BALANCE_ERROR = "UPDATED_LEAVE_BALANCE_ERROR";
export const UPDATED_LEAVE_BALANCE_LOADING = "UPDATED_LEAVE_BALANCE_LOADING";
// document view
export const VIEW_DOCUMENT_SUCCESS = "VIEW_DOCUMENT_SUCCESS";
export const VIEW_DOCUMENT_ERROR = "VIEW_DOCUMENT_ERROR";
export const VIEW_DOCUMENT_ACTION = "VIEW_DOCUMENT_ACTION";
export const VIEW_DOCUMENT_LOADING = "VIEW_DOCUMENT_LOADING";
export const SUPERVISOR_TEAM_LOADING = "SUPERVISOR_TEAM_LOADING";
export const SUPERVISOR_TEAM_SUCCESS = "SUPERVISOR_TEAM_SUCCESS";
export const SUPERVISOR_TEAM_ERROR = "SUPERVISOR_TEAM_ERROR";
export const SUPERVISOR_TEAM_ACTION = "SUPERVISOR_TEAM_ACTION";
export const SUPERVISOR_ALL_ENTRIES_ACTION = "SUPERVISOR_ALL_ENTRIES_ACTION";
export const SUPERVISOR_ALL_ENTRIES_SUCCESS = "SUPERVISOR_ALL_ENTRIES_SUCCESS";
export const SUPERVISOR_ALL_ENTRIES_ERROR = "SUPERVISOR_ALL_ENTRIES_ERROR";
export const SUPERVISOR_ALL_ENTRIES_LOADING = "SUPERVISOR_ALL_ENTRIES_LOADING";
export const POLICY_CONTENT_ACTION = "POLICY_CONTENT_ACTION";
export const POLICY_CONTENT_SUCCESS = "POLICY_CONTENT_SUCCESS";
export const POLICY_CONTENT_LOADING = "POLICY_CONTENT_LOADING";
export const POLICY_CONTENT_ERROR = "POLICY_CONTENT_ERROR";
export const GET_POLICY_ACTION = "GET_POLICY_ACTION";
export const GET_POLICY_LOADING = "GET_POLICY_LOADING";
export const GET_POLICY_SUCCESS = "GET_POLICY_SUCCESS";
export const GET_POLICY_ERROR = "GET_POLICY_ERROR";
export const UPDATE_POLICY_ACTION = "UPDATE_POLICY_ACTION";
export const UPDATE_POLICY_SUCCESS = "UPDATE_POLICY_SUCCESS";
export const UPDATE_POLICY_ERROR = "UPDATE_POLICY_ERROR";
export const UPDATE_POLICY_LOADING = "UPDATE_POLICY_LOADING";
export const OPEN_POLICY_LOADING = "OPEN_POLICY_LOADING";
export const OPEN_POLICY_ACTION = "OPEN_POLICY_ACTION";
export const OPEN_POLICY_ERROR = "OPEN_POLICY_ERROR";
export const OPEN_POLICY_SUCCESS = "OPEN_POLICY_SUCCESS";
export const DELETE_SIGNATURE_ACTION = "DELETE_SIGNATURE_ACTION";
export const DELETE_SIGNATURE_ERROR = "DELETE_SIGNATURE_ERROR";
export const DELETE_SIGNATURE_LOADING = "DELETE_SIGNATURE_LOADING";
export const DELETE_SIGNATURE_SUCCESS = "DELETE_SIGNATURE_SUCCESS";
export const EDIT_SIGNATURE_ACTION = "EDIT_SIGNATURE_ACTION";
export const EDIT_SIGNATURE_ERROR = "EDIT_SIGNATURE_ERROR";
export const EDIT_SIGNATURE_LOADING = "EDIT_SIGNATURE_LOADING";
export const EDIT_SIGNATURE_SUCCESS = "EDIT_SIGNATURE_SUCCESS";
export const ADD_SIGNATURE_ACTION = "ADD_SIGNATURE_ACTION";
export const ADD_SIGNATURE_ERROR = "ADD_SIGNATURE_ERROR";
export const ADD_SIGNATURE_LOADING = "ADD_SIGNATURE_LOADING";
export const ADD_SIGNATURE_SUCCESS = "ADD_SIGNATURE_SUCCESS";
export const GET_SIGNATURE_LOADING = "GET_SIGNATURE_LOADING";
export const GET_SIGNATURE_SUCCESS = "GET_SIGNATURE_SUCCESS";
export const GET_SIGNATURE_ERROR = "GET_SIGNATURE_ERROR";
export const GET_SIGNATURE_ACTION = "GET_SIGNATURE_ACTION";
export const ALL_SIGNATURE_ACTION = "ALL_SIGNATURE_ACTION";
export const ALL_SIGNATURE_LOADING = "ALL_SIGNATURE_LOADING";
export const ALL_SIGNATURE_SUCCESS = "ALL_SIGNATURE_SUCCESS";
export const ALL_SIGNATURE_ERROR = "ALL_SIGNATURE_ERROR";
export const VIEW_SIGNATURE_ACTION = "VIEW_SIGNATURE_ACTION";
export const VIEW_SIGNATURE_ERROR = "VIEW_SIGNATURE_ERROR";
export const VIEW_SIGNATURE_LOADING = "VIEW_SIGNATURE_LOADING";
export const VIEW_SIGNATURE_SUCCESS = "VIEW_SIGNATURE_SUCCESS";

export const FINANCIAL_REPORT_FETCH_ACTION = "FINANCIAL_REPORT_FETCH_ACTION";
export const FINANCIAL_REPORT_FETCH_LOADING = "FINANCIAL_REPORT_FETCH_LOADING";
export const FINANCIAL_REPORT_FETCH_SUCCESS = "FINANCIAL_REPORT_FETCH_SUCCESS";
export const FINANCIAL_REPORT_FETCH_ERROR = "FINANCIAL_REPORT_FETCH_ERROR";
